import axios from 'axios';
import { getActiveTimezone } from '../utils/timezone';

const API_BASE = import.meta.env.VITE_API_URL || 'http://localhost:5000';

const api = axios.create({
  baseURL: API_BASE,
  headers: {
    'Content-Type': 'application/json'
  },
  timeout: 60000 // 60 seconds to handle Render cold starts
});

// Add request interceptor to include timezone
api.interceptors.request.use(
  config => {
    // Add timezone to all requests
    const timezone = getActiveTimezone();
    if (config.method === 'get') {
      config.params = { ...config.params, timezone };
    } else {
      config.data = { ...config.data, timezone };
    }
    return config;
  },
  error => Promise.reject(error)
);

// Add response interceptor for error handling
api.interceptors.response.use(
  response => response,
  error => {
    console.error('API Error:', error);
    return Promise.reject(error);
  }
);

export const gameAPI = {
  /**
   * Get daily word information
   */
  getDailyWord: async () => {
    const response = await api.get('/api/daily-word');
    return response.data;
  },

  /**
   * Validate if a word is in the word list
   */
  validateWord: async (guess) => {
    const response = await api.post('/api/validate', { guess });
    return response.data;
  },

  /**
   * Check a guess against the target word
   */
  checkGuess: async (guess, gameNumber) => {
    const response = await api.post('/api/check-guess', {
      guess,
      game_number: gameNumber
    });
    return response.data;
  },

  /**
   * Get word statistics
   */
  getWordStats: async () => {
    const response = await api.get('/api/word-stats');
    return response.data;
  },

  /**
   * Health check
   */
  healthCheck: async () => {
    const response = await api.get('/api/health');
    return response.data;
  }
};

export default api;